export default __webpack_public_path__ + "static/media/houseofcrom.c7c962de.jpg";